import { useClient, useDictionary } from "@adamlip/okeoke.client"
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "@nextui-org/react"
import MenuOptionsSelector from "components/MenuOptionsSelector"
import { useEffect, useRef, useState } from "react"
import { isDesktop } from "react-device-detect"
import toast from "react-hot-toast"

export default function MenuSelectModal({
  isOpen,
  setIsOpen,
  setShowMenuOptions,
  showMenuOptions,
  sizes,
  selectedMenuSize,
  setSelectedMenuSize,
  closeItemModal,
  setSize,
  addItem,
  setNoMenuSelected,
}) {
  const { getValue } = useDictionary()
  const { getName } = useClient()

  const [localSizes, setLocalSizes] = useState(null)
  const [normalSizeCount, setNormalSizeCount] = useState(0)
  const [menuSizeCount, setMenuSizeCount] = useState(0)
  const [selectedAssembledItem, setSelectedAssembledItem] = useState(null)
  const sizeGroupsValidation = useRef({})
  const selectedAssembledItems = useRef({})

  const handleClickOnMenu = () => {
    setShowMenuOptions(true)
    if (menuSizeCount === 1) {
      setSelectedMenuSize(
        localSizes?.filter((size) => size?.attributes?.menuSize)[0]
      )
    }
    closeItemModal()
  }

  const handleClickOnNotMenu = () => {
    setIsOpen(false)
    setNoMenuSelected(true)
  }

  const handleSelectSize = (size) => {
    setSelectedMenuSize(size)
    setSize(size.uuid)
    closeItemModal()
  }

  const setSizeGroupsValidation = (groupUUID, valid) => {
    sizeGroupsValidation.current = {
      ...sizeGroupsValidation.current,
      [groupUUID]: valid,
    }
  }

  const addToBasket = () => {
    if (selectedAssembledItem == null) {
      toast.error(getValue("app_v2_menu_no_menuSize_selected"))
    } else {
      if (!selectedAssembledItem?.valid) {
        toast.error(getValue("app_v2_menu_menuSize_invalid"))
      } else {
        let values = Object.values(sizeGroupsValidation.current)
        let invalid = values.some((value) => !value)

        if (invalid) {
          toast.error(getValue("app_v2_menu_invalid"))
        } else {
          let selectedItems = []
          for (let group of Object.values(selectedAssembledItems.current)) {
            let items = Object.values(group)?.filter((item) => item.count > 0)
            selectedItems = [...selectedItems, ...items]
          }
          let parentItemUUID = addItem(selectedAssembledItem)
          if (parentItemUUID) {
            for (let item of selectedItems) {
              addItem(item, parentItemUUID)
            }
            toast.success(getValue("app_v2_add_menu_success"))
            setIsOpen(false)
          } else {
            toast.error(getValue("app_v2_add_item_error"))
          }
        }
      }
    }
  }

  useEffect(() => {
    if (localSizes) {
      let normalCount = 0
      let menuCount = 0
      for (let size of localSizes) {
        if (size?.attributes?.menuSize) {
          menuCount++
        } else {
          normalCount++
        }
      }
      setNormalSizeCount(normalCount)
      setMenuSizeCount(menuCount)
    } else {
      setShowMenuOptions(false)
      setSelectedMenuSize(null)
      setNormalSizeCount(0)
      setMenuSizeCount(0)
    }
    //eslint-disable-next-line
  }, [localSizes])

  useEffect(() => {
    if (normalSizeCount === 0 && menuSizeCount === 1) {
      setSelectedMenuSize(localSizes[0])
      setShowMenuOptions(true)
    }
    //eslint-disable-next-line
  }, [normalSizeCount, menuSizeCount])

  useEffect(() => {
    if (isOpen) {
      setLocalSizes([...sizes])
    } else {
      setLocalSizes(null)
    }
  }, [isOpen, sizes])

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={() => setIsOpen(!isOpen)}
      size={isDesktop ? "xl" : "2xl"}
      radius="none"
      className="bg-background rounded-lg"
      classNames={{
        base: `m-0 max-w-[820px] md:max-w-[500px] h-[80vh]`,
        wrapper: "sm:items-end md:items-center",
        closeButton:
          "z-50 bg-[var(--button-bg-color)] text-[var(--button-text-color)]",
      }}
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="">
              {getValue("app_v2_menu_select_menu_title")}
            </ModalHeader>
            <ModalBody
              className="flex flex-col"
              style={{ height: "calc(100% - 132px)" }}
            >
              {!showMenuOptions && (
                <>
                  <Button onPress={handleClickOnMenu}>
                    {getValue("app_v2_menu_select_menu")}
                  </Button>
                  <Button onPress={handleClickOnNotMenu}>
                    {getValue("app_v2_menu_select_no_menu")}
                  </Button>
                </>
              )}

              {showMenuOptions && (
                <>
                  {selectedMenuSize?.uuid == null &&
                    localSizes
                      ?.filter((size) => size?.attributes?.menuSize)
                      .map((size) => (
                        <Button
                          key={size.uuid}
                          onPress={() => handleSelectSize(size)}
                        >
                          {getName(size.name)}
                        </Button>
                      ))}
                  {selectedMenuSize?.uuid != null && (
                    <MenuOptionsSelector
                      selectedSize={selectedMenuSize}
                      setSizeGroupsValidation={setSizeGroupsValidation}
                      selectedAssembledItems={selectedAssembledItems}
                      setSelectedAssembledItem={setSelectedAssembledItem}
                      selectedAssembledItem={selectedAssembledItem}
                    />
                  )}
                </>
              )}
            </ModalBody>
            <ModalFooter>
              {selectedMenuSize?.uuid != null && (
                <Button
                  onPress={() => addToBasket()}
                  color={`${selectedAssembledItem != null ? "primary" : "default"
                    }`}
                >
                  {getValue("app_v2_menu_to_basket")}
                </Button>
              )}
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  )
}
